import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";
import { TESTIMONIALS, SITE } from "../lib/site";

function Card({ t }) {
  return (
    <div
      className="w-[360px] md:w-[420px] mx-4 bg-[#F5F5F0] border border-[#E5E5E0] p-7 hover:border-[#CC5500] transition-colors duration-300"
      data-testid={`testimonial-${t.name.replace(/\s+/g, '-').toLowerCase()}`}
    >
      <div className="flex gap-1 mb-4">
        {[...Array(5)].map((_, i) => (
          <Star key={i} size={14} fill="#CC5500" strokeWidth={0} />
        ))}
      </div>
      <p className="font-serif-display text-xl lg:text-2xl italic text-[#1C1C1A] leading-snug tracking-tight">
        "{t.body}"
      </p>
      <div className="mt-6 flex items-baseline justify-between border-t border-[#E5E5E0] pt-4">
        <span className="font-sans-body text-sm text-[#1C1C1A]">{t.name}</span>
        <span className="font-sans-body text-[10px] uppercase tracking-[0.2em] text-[#4A4A46]">
          via {t.source}
        </span>
      </div>
    </div>
  );
}

export default function Reviews() {
  return (
    <section
      id="reviews"
      className="py-24 lg:py-32 border-t border-[#E5E5E0] overflow-hidden"
      data-testid="reviews-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-7">
            <span className="font-sans-body text-[11px] uppercase tracking-[0.3em] text-[#CC5500]">
              (Reviews)
            </span>
            <h2 className="mt-4 font-serif-display text-4xl lg:text-6xl tracking-tightest text-[#1C1C1A] leading-[0.95]">
              Words from
              <br />
              <em className="font-light">our neighbors.</em>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pt-10 flex flex-col gap-4">
            <p className="font-sans-body text-base text-[#4A4A46] leading-relaxed">
              Verified reviews from Yelp and HomeAdvisor — and a few hand-written
              cards we kept on the office wall.
            </p>
            <div className="flex gap-3">
              <a
                href={SITE.yelp}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reviews-yelp-link"
                className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#1C1C1A] hover:text-[#CC5500] border-b border-[#1C1C1A] hover:border-[#CC5500] transition-colors py-1"
              >
                Read on Yelp →
              </a>
              <a
                href={SITE.homeAdvisor}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reviews-homeadvisor-link"
                className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#1C1C1A] hover:text-[#CC5500] border-b border-[#1C1C1A] hover:border-[#CC5500] transition-colors py-1"
              >
                Read on HomeAdvisor →
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="marquee-fade">
        <Marquee pauseOnHover gradient={false} speed={32}>
          {TESTIMONIALS.map((t, i) => (
            <Card key={i} t={t} />
          ))}
        </Marquee>
      </div>
    </section>
  );
}
